module.exports = __webpack_public_path__ + "img/224.d34c1022.png";